import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ArticleCard } from "../components/ArticleCard";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api.get("/articles", { params: { q, limit: 50 } })
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10" data-testid="search-page">
      <h1 className="font-devanagari font-black text-3xl sm:text-4xl text-zinc-900">"{q}" के परिणाम</h1>
      <p className="mt-1 font-hind text-zinc-500">{loading ? "खोज रहे हैं..." : `${items.length} खबरें मिलीं`}</p>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((a) => <ArticleCard key={a.id} a={a} />)}
      </div>
      {!loading && items.length === 0 && q && (
        <div className="text-center py-20 font-devanagari text-zinc-500">कोई परिणाम नहीं मिला.</div>
      )}
    </div>
  );
}
